import React from 'react';

export default function ToggleInstallationCard(props) {
    return (
        <div className="card-header">
            <button
                className="btn btn-primary pull-right collapsed"
                type="button"
                data-toggle="collapse"
                data-target="#settingsInstallationCollapse"
                aria-expanded="false"
                aria-controls="settingsInstallationCollapse"
            >
                <span className="if-collapsed">Uitklappen</span>
                <span className="if-not-collapsed">Inklappen</span>
            </button>
            <h4>Installatie</h4>
        </div>
    );
}